module.exports = __webpack_public_path__ + "img/foursome-tepeji.975c1656.jpg";